import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-cpf-mask-type',
  templateUrl: './cpf-mask-type.component.html'
})
export class CpfMaskTypeComponent extends FieldType {}
